import { Link } from "react-router-dom";
import { useRegionConfig } from "src/RegionConfigProvider";

export default function Logo({ url, logoSrc }) {
    const { logo } = useRegionConfig();

    const img = (
        <img
            src={logoSrc || logo?.src}
            style={{ width: 160, height: "auto" }}
            alt={logo?.alt || "Logo"}
        />
    );

    const isExternal = url?.startsWith("http");

    if (isExternal) {
        return (
            <a href={url} target="_blank" rel="noopener noreferrer">
                {img}
            </a>
        );
    }

    return <Link to={url || "/"}>{img}</Link>;
}
